import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import ErrorBoundary from "./components/Common/ErrorBoundary";
import { UserProvider } from "./UserContext";

import { Provider } from "react-redux";
import { store, persistor } from "./store";
import { PersistGate } from "redux-persist/integration/react";
import { registerServiceWorker } from "./registerServiceWorker";
import { bootstrapChunkErrorRecovery } from "./bootstrapChunkErrorRecovery";
import { bootstrapUltraBackendProbe } from "./calendar/debug/ultraBackendProbe";
import { bootstrapUltraSessionDebug } from "./calendar/debug/ultraSessionDebug";
import { bootstrapCalendarViewResetHotkey } from "./calendar/debug/calendarViewReset";
import { bootstrapIosKeyboardScrollRestore } from "./utils/iosKeyboardScrollRestore";

const container = document.getElementById("root");
const root = createRoot(container);

bootstrapChunkErrorRecovery();
registerServiceWorker();
bootstrapUltraSessionDebug(store);
bootstrapUltraBackendProbe(store);
bootstrapCalendarViewResetHotkey();
bootstrapIosKeyboardScrollRestore();

root.render(
   <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
         <UserProvider>
            <ErrorBoundary
               name="app"
               title="Aplicația a întâmpinat o eroare"
            >
               <App />
            </ErrorBoundary>
         </UserProvider>
      </PersistGate>
   </Provider>
);
